import {
  TouchableOpacity,
  Image,
  View,
  Text,
  StyleSheet,
  ImageBackground,
} from "react-native";
import {
  AvatarFrameVipPng,
  AvatarModalPng,
  BtnCloseModal,
  BtnEditModal,
  BtnPhotoModal,
  ChipPng,
  NamePng,
  ProfileImage,
  ProfileScore,
  ReportPng,
  StarPng,
  StatisticsUpLightPng,
  VipBadgeFramePng,
} from "../../../assets";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useRef } from "react";
import {
  reportUserRequest,
  updateProfileRequest,
} from "../../../store/auth/authActions";
import { getAvatarUrl, uploadFile } from "../../../utils/axiosInstance";
import { selectProfile } from "../../../store/auth/authReducer";
import { ReportType } from "../../../store/types";

type MessagesModalProps = {
  onClose: () => void;
  visible: boolean;
  onOpenProfileEditModal: () => void;
  player?: {
    rank: number;
    playerId: string;
    username: string;
    avatarFileId: string | null;
    totalChips: number;
    level: number;
  };
};

export const TopSectionDesktop = ({
  onClose,
  visible,
  onOpenProfileEditModal,
  player,
}: MessagesModalProps) => {
  // const player = useSelector((s: RootState) => s.auth.user);
  const authUser = useSelector(selectProfile);
  const isVip = useSelector((s: RootState) => s.auth.user?.isVip);
  const userToShow = player
    ? {
        username: player.username,
        avatarFileId: player.avatarFileId,
        chips: player.totalChips,
        level: player.level,
      }
    : authUser;
  const onReport = () => {
    if (!player?.playerId) {
      console.warn("[Report] No viewedUserId, cannot send report");
      return;
    }
    dispatch(
      reportUserRequest({
        reportedId: player?.playerId,
        reportType: ReportType.INAPPROPRIATE_USERNAME,
        reason: "Reported from profile button",
        gameContext: "PROFILE_SCREEN",
      }),
    );
  };
  const isOwnProfile = !player || player.playerId === authUser?.id;
  const level = useSelector((s: RootState) => s.auth.statistics?.level.current);
  const inputRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();
  const pickFile = () => inputRef.current?.click();
  const onFileChosen = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target;
    const file: File = (target.files as FileList)[0];

    try {
      const fileId = await uploadFile(file);

      dispatch(
        updateProfileRequest({
          avatarFileId: String(fileId),
        }),
      );
    } catch (err: any) {
      console.error("Avatar upload failed:", err);
    }
  };
  const AVATAR_SIZE = 108;

  return (
    <View>
      {/* Buttons */}
      {isOwnProfile && (
        <TouchableOpacity
          onPress={onOpenProfileEditModal}
          style={styles.photoButton}
        >
          <Image source={BtnEditModal} style={styles.iconButtonImage} />
        </TouchableOpacity>
      )}
      {isOwnProfile && (
        <View>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={onFileChosen}
          />
          <TouchableOpacity onPress={pickFile} style={styles.editButton}>
            <Image source={BtnPhotoModal} style={styles.iconButtonImage} />
          </TouchableOpacity>
        </View>
      )}

      <View style={styles.avatarWrapper}>
        <Image
          source={isVip ? AvatarFrameVipPng : AvatarModalPng}
          // source={AvatarModalPng}
          style={isVip ? styles.avatarVip : styles.avatarBg}
          resizeMode="contain"
        />
        {isOwnProfile && isVip && (
          <Image
            source={VipBadgeFramePng}
            style={{
              position: "absolute",
              top: -12,
              left: 130,
              width: 35,
              height: 35,
              zIndex: 22,
            }}
          />
        )}
        <Image
          source={
            userToShow?.avatarFileId
              ? { uri: getAvatarUrl(userToShow.avatarFileId) }
              : ProfileImage
          }
          style={[
            styles.avatarImage,
            {
              width: AVATAR_SIZE,
              height: AVATAR_SIZE,
              borderRadius: AVATAR_SIZE / 2,
            },
          ]}
          resizeMode="cover"
        />

        {/* <Image
          source={ProfileScore}
          style={styles.scoreBadge}
          resizeMode="contain"
        />
        <Text style={styles.scoreText}>{level}</Text> */}
        {/* <View style={styles.scoreIcon}>
          <ImageBackground
            source={ProfileScore}
            style={styles.scoreIcon}
            resizeMode="contain"
          >
            <Text style={styles.scoreText}>{player?.level}</Text>
          </ImageBackground>
        </View> */}
      </View>

      <TouchableOpacity onPress={onClose} style={styles.closeButton}>
        <Image source={BtnCloseModal} style={styles.iconButtonImage} />
      </TouchableOpacity>

      {/* Stats Header */}
      <View style={styles.statsHeader}>
        <View style={styles.statsItem}>
          <View style={styles.statsItem}>
            <Image
              source={StarPng}
              resizeMode="contain"
              style={styles.statsIcon}
            />
            <Text style={styles.statsText}>{level}</Text>
          </View>
          {!isOwnProfile && (
            <View style={{ width: 40 }}>
              <TouchableOpacity
                style={styles.circle}
                onPress={onReport}
                // onLongPress={() => setShowTip(true)}
              >
                <Image source={ReportPng} style={styles.icon} />
              </TouchableOpacity>
            </View>
          )}
        </View>

        <View style={styles.nameWrapper}>
          <Image source={NamePng} style={styles.nameBg} resizeMode="contain" />
          <View style={styles.centeredContent}>
            <Text style={styles.nameText}>{userToShow?.username}</Text>
          </View>
        </View>

        <View style={styles.statsItem}>
          <Image
            source={ChipPng}
            resizeMode="contain"
            style={styles.statsIcon}
          />
          <Text style={styles.statsText}>{userToShow?.chips}</Text>
        </View>
      </View>

      <View style={styles.divider}>
        <Image
          source={StatisticsUpLightPng}
          style={{ width: 428, height: 26 }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  circle: {
    width: 36,
    height: 36,
    borderRadius: 32,
    backgroundColor: "#d3d3d3",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    width: 25,
    height: 25,
    resizeMode: "contain",
  },
  photoButton: {
    zIndex: 1,
    position: "absolute",
    width: 50,
    height: 50,
    top: -24,
    right: 80,
  },
  editButton: {
    zIndex: 1,
    position: "absolute",
    width: 50,
    height: 50,
    top: -24,
    right: 145,
  },
  closeButton: {
    zIndex: 1,
    position: "absolute",
    width: 50,
    height: 50,
    top: -24,
    right: 17,
  },
  iconButtonImage: {
    width: 50,
    height: 50,
  },
  avatarWrapper: {
    position: "relative",
    // display: "flex",
    alignItems: "center",
  },
  avatarBg: {
    // width: "100%",
    width: 180,

    height: 144,
    position: "absolute",
    top: -76,
    left: 5,
  },
  avatarVip: {
    width: 140,

    height: 118,
    position: "absolute",
    top: -62,
    left: 24,
  },
  avatarImage: {
    position: "absolute",
    top: -57,
    left: 40,
    alignSelf: "center",
  },
  scoreBadge: {
    width: 38,
    height: 38,
    position: "absolute",
    top: -20,
    left: 140,
  },
  // scoreText: {
  //   width: 38,
  //   height: 38,
  //   position: "absolute",
  //   top: -14,
  //   left: 150,
  //   color: "#fff",
  //   fontSize: 18,
  //   fontWeight: "600",
  // },
  statsHeader: {
    position: "relative",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 24,
    width: "52%",
    height: 20,
    marginLeft: "24%",
  },
  statsItem: {
    flexDirection: "row",
    alignItems: "center",
    width: 60,
  },
  statsIcon: {
    width: 28,
    height: 28,
    marginTop: 4,
  },
  statsText: {
    color: "white",
    fontSize: 20,
    marginLeft: 5,
  },
  nameWrapper: {
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
  },
  nameBg: {
    width: 224,
    height: 38,
    position: "absolute",
  },
  centeredContent: {
    zIndex: 1,
  },
  scoreIcon: {
    width: 38,
    height: 38,
    position: "absolute",
    top: -10,
    marginLeft: 40,
  },
  scoreText: {
    width: 38,
    height: 38,
    position: "absolute",
    top: 5,
    marginLeft: 0,
    color: "#fff",
    fontWeight: "600",
    fontSize: 18,
    textAlign: "center",
  },
  nameText: {
    // position: "absolute",
    // top: 4,
    // left: 80,
    // flex: 1,
    color: "white",
    fontSize: 20,
    fontWeight: "500",
    textAlign: "center",
    // marginLeft: 3,
  },
  divider: {
    marginTop: 10,
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
});
